<template>
    <div class="alignment-specialist-container hidden-first" id="alignment-specialist">
        <section class="container">
            <div class="row-custom">
                <div class="team-col">
                    <h1>Preventieve Tandheelkunde</h1>
                    <p>
                        Bij Tandzorg Gestel geloven we dat voorkomen beter is dan genezen. Onze preventieve tandheelkunde richt zich op het behoud van een gezond gebit door middel van regelmatige controles, professionele gebitsreiniging en persoonlijk advies. Tijdens controles kijken we niet alleen naar uw tanden, maar ook naar uw tandvlees en mondgezondheid in het algemeen. 
                        We geven u praktische tips voor mondverzorging thuis, zoals de juiste poets- en flosstechnieken. Door problemen vroegtijdig te signaleren, helpen we u om ingrijpende behandelingen in de toekomst te voorkomen.
                    </p>
                </div>
                <div class="team-col image-col-right">
                    <img src="../assets/images/miladcontrole.jpg" id="the-practice-img">
                </div>
            </div>
        </section>
    </div>
</template>

<script>

export default {
    name: "AlignmentSpecialist",
    mounted() {
        const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if(entry.isIntersecting){
            entry.target.classList.add('show-first')
          } 
        })
      })

      const hiddenElements = document.querySelectorAll('.hidden-first')
      hiddenElements.forEach((el) => observer.observe(el))
    }
}
</script>

<style scoped>
.hidden-first {
  opacity: 0;
  transform: translateX(-100px);
  transition: all 1.5s;
}
.show-first {
  opacity: 1;
  transform: translateX(0);
}
.team-col {
    flex-basis: 48%;
}
.row-custom .image-col-right{
  display: flex;
  justify-content: center;
}

.row-custom {
    margin-bottom: 0px;
}
.team-col img {
    width: 100%;
    max-width: 600px;
}
.team-col h1 {
    padding-top: 0;
    color: var(--blue);
}
.team-col p {
    padding: 15px 0 0;
    font-size: 1.4rem;
}
#the-practice-img {
    width: 100%;
    height: 400px;
    object-fit: cover;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.alignment-specialist-container {
    padding: 4rem 0;
}


@media(max-width: 991px) {
    .row-custom {
        margin-bottom: 20px;
    }
    .row-custom {
        flex-direction: column;
    }
    h1 {
        font-size: 20px;
        text-align: center;
    }

    .team-col img {
        max-width: 100%;
    }

    .team-col p {
        padding: 7px 0px 0px;
    }

    #the-practice-img {
        height: 200px;
    }

}
</style>